module.exports = __webpack_public_path__ + "media/application/images/publish-callout-bg-fc0b483e15587a5bfb5eb93202a2b6ad.png";